function updateAvailabilityState(){
  var details=document.querySelector('.filter-details');
  if(!details)return;
  var summary=details.querySelector('summary');
  var checked=details.querySelector('input:not(:disabled):checked');
  var current=summary.querySelector('.availability-current');
  var group=details.parentElement;
  var clearAll=group.querySelector('.availability-clear-all');
  var popover=details.querySelector('.availability-popover');
  var clear=popover.querySelector('.availability-clear');

  if(checked){
    if(!current){
      current=document.createElement('span');
      current.className='availability-current';
      summary.insertBefore(current,summary.querySelector('.toolbar-chevron'));
    }
    current.textContent=checked.nextElementSibling?checked.nextElementSibling.textContent:'In stock';
    if(!clearAll){
      clearAll=document.createElement('button');
      clearAll.type='button';
      clearAll.className='availability-clear-all';
      clearAll.textContent='Clear all';
      group.appendChild(clearAll);
    }
    if(!clear){
      clear=document.createElement('button');
      clear.type='button';
      clear.className='availability-clear';
      clear.textContent='Clear';
      popover.appendChild(clear);
    }
  }else{
    if(current)current.remove();
    if(clearAll)clearAll.remove();
    if(clear)clear.remove();
  }
}

function clearAvailability(){
  document.querySelectorAll('.availability-popover input').forEach(function(input){input.checked=false});
  updateAvailabilityState();
}

function disableOutOfStock(){
  document.querySelectorAll('.availability-popover label').forEach(function(label){
    var text=label.querySelector('span');
    var input=label.querySelector('input');
    if(input&&text&&text.textContent.trim().toLowerCase()==='out of stock'){
      input.checked=false;
      input.disabled=true;
      input.setAttribute('aria-disabled','true');
    }
  });
}

document.querySelectorAll('.filter-details').forEach(function(details){
  details.addEventListener('toggle',function(){
    if(details.open)document.querySelectorAll('.filter-details').forEach(function(other){if(other!==details)other.open=false});
  });
});

document.addEventListener('click',function(event){
  if(!event.target.closest('.filter-details'))document.querySelectorAll('.filter-details').forEach(function(details){details.open=false});
  if(event.target.closest('.availability-clear,.availability-clear-all')){
    event.preventDefault();
    clearAvailability();
  }
});

document.querySelectorAll('.collection-filter-form input').forEach(function(input){
  input.addEventListener('change',function(){
    if(input.closest('.availability-popover')){
      updateAvailabilityState();
      return;
    }
    input.form.submit();
  });
});

document.querySelectorAll('.view-icon[data-grid-columns]').forEach(function(button){
  button.addEventListener('click',function(){
    var grid=document.querySelector('.collection-page .product-grid');
    if(!grid)return;
    var compact=!button.querySelector('.official-grid-four');
    var columns=compact?'12':'5';
    grid.style.gridTemplateColumns='repeat('+columns+',minmax(0,1fr))';
    grid.classList.toggle('collection-grid--compact',compact);
    document.querySelectorAll('.view-icon').forEach(function(item){item.classList.remove('active')});
    button.classList.add('active');
  });
});

document.querySelectorAll('.sort-details').forEach(function(details){
  details.addEventListener('toggle',function(){
    if(details.open)document.querySelectorAll('.filter-details,.sort-details').forEach(function(other){if(other!==details)other.open=false});
  });
});

document.addEventListener('DOMContentLoaded',function(){
  disableOutOfStock();
  var buttons=document.querySelectorAll('.view-icon[data-grid-columns]');
  if(buttons.length){
    buttons.forEach(function(button,index){button.classList.toggle('active',index===0)});
    var grid=document.querySelector('.collection-page .product-grid');
    if(grid){
      grid.style.gridTemplateColumns='repeat(5,minmax(0,1fr))';
      grid.classList.remove('collection-grid--compact');
    }
  }
  updateAvailabilityState();
});

disableOutOfStock();
